export default __webpack_public_path__ + "static/media/insight_powered_by.8c493c6d.svg";